import { Component, OnInit } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {
  public focus;
  public listTitles: any[];
  public location: Location;
  userName = '';

  constructor(location: Location, private authService: AuthService) {
    this.location = location;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const user = this.authService.getUser() as any;
    if (user) {
      this.userName = user.name;
    }
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
  
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
  
    return 'Dashboard';
  }

  onLogout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.reload();
  }
}
